import React from 'react';

interface MiniButton {
  children: React.ReactNode;
  onClick: () => void;
}

const MiniButton = ({ children, onClick }: MiniButton) => (
  <button
    className="whatcrm-widget-audio__mini-btn"
    onClick={() => onClick()}
    type="button"
  >
    {children}
  </button>
);

export default MiniButton;
